export default function TeamBoardCard({ name, position, image }) {
  return (
    <div className="group/item relative cursor-auto h-max m-auto sm:m-0 flex flex-col justify-center items-center sm:items-center">
      <div className="max-w-[414px] sm:max-h-[607px] 2xl:max-w-full 2xl:max-h-full w-full h-full relative">
        <img
          src={image}
          alt="Member"
          className="w-full h-full object-contain max-h-[360px] sm:max-h-none transition-all group-hover/item:opacity-60"
        />
      </div>
      <div className="w-[100%] transition-all group-hover/item:opacity-60">
        <p className="text-xl/[26px] pt-6">{name}</p>
      </div>
      <div className="w-[100%] transition-all group-hover/item:opacity-60">
        <p className="text-xl/[26px]">{position}</p>
      </div>
    </div>
  );
}
